import * as enums from './enums';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import utc from 'dayjs/plugin/utc';
import envConfig from './env-config';

dayjs.extend(minMax);
dayjs.extend(utc)

export { enums };

/*******************************************************************************
 * Async version of sleep/wait
 * @param {number} ms The number of milliseconds to sleep
 ******************************************************************************/
export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const minToMs = (minutes: number) => minutes * 60 * 1000;

/*******************************************************************************
 * Returns the current date in a common format
 ******************************************************************************/
export const getCurrentUTCDate = () => {
  return dayjs().utc().format('YYYY-MM-DDTHH:mm:ss')
}

export const getUnumCompanyCode = () => {
  switch(envConfig.upEnvironment) {
    case 'PRODUCTION':
      return 1;
    case 'DEVELOPMENT':
      return 83;
    default:
      return 84;
  }
}

/*******************************************************************************
 * Opens a new window with a POST request
 * @param url The url to open
 * @param params The parameters to send
 * @param windowFeatures A comma-separated list of requested features
 * of the new window https://developer.mozilla.org/en-US/docs/Web/API/Window/open#parameters
 * @param name The name of the window
 ******************************************************************************/
export const openWindowWithPost = (
  url: string,
  params: Record<string, string> = {},
  windowFeatures = 'menubar=no,resizable=yes,scrollbars=yes,status=yes,height=1024,width=1280,left=0,top=0',
  name = `${Date.now()}`,
) => {
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  form.setAttribute('target', name);

  Object.entries(params).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  if (name !== '_blank') { window.open('', name, windowFeatures); }
  form.submit();
  document.body.removeChild(form);
};